import * as CONST from "./actionTypes";

export const getService = (payload, callBack) => {
  return {
    type: CONST.GET_SERVICES,
    payload,
    callBack,
  };
};

export const getServicesSuccess = (payload, callBack) => {
  return {
    type: CONST.GET_SERVICES_SUCCESS,
    payload,
    callBack,
  };
};

export const getServicesFail = (payload, callBack) => {
  return {
    type: CONST.GET_SERVICES_FAIL,
    payload,
    callBack,
  };
};

export const updateServiceList = (payload, callBack) => {
  return {
    type: CONST.UPDATE_SERVICES_LIST,
    payload,
    callBack,
  };
};

export const getServiceById = (payload, callBack) => {
  return {
    type: CONST.GET_SERVICES_BY_ID,
    payload,
    callBack,
  };
};

export const getServicesByIdSuccess = (payload, callBack) => {
  return {
    type: CONST.GET_SERVICES_BY_ID_SUCCESS,
    payload,
    callBack,
  };
};

export const getServicesByIdFail = (payload, callBack) => {
  return {
    type: CONST.GET_SERVICES_BY_ID_FAIL,
    payload,
    callBack,
  };
};

export const removeService = (payload, callBack) => {
  return {
    type: CONST.REMOVE_SERVICE,
    payload,
    callBack,
  };
};

export const removeServiceSuccess = (payload, callBack) => {
  return {
    type: CONST.REMOVE_SERVICE_SUCCESS,
    payload,
    callBack,
  };
};

export const removeServiceFail = (payload, callBack) => {
  return {
    type: CONST.REMOVE_SERVICE_FAIL,
    payload,
    callBack,
  };
};

export const addService = (payload, callBack) => {
  return {
    type: CONST.ADD_SERVICE,
    payload,
    callBack,
  };
};

export const editService = (payload, callBack) => {
  return {
    type: CONST.EDIT_SERVICE,
    payload,
    callBack,
  };
};
